var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Roles',{staticClass:"project-roles",attrs:{"value":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }